import { useState, useEffect } from "react";
import { slideShow } from "../interfaces/interface";
import "../css/Slider.css";
import Button from "./ButtonRegister";
// import { Link } from "react-router-dom";
import sliderImage1 from  "../assets/WhatsApp Image 2024-09-23 at 4.44.31 PM 1.png";
import sliderImage2 from  "../assets/landingpage.jpg";
import sliderImage3 from  "../assets/74d433cf-cebd-40d1-a999-a1e66859cba5.jpg";


const Slider = () => {
    const slideShowItems: slideShow[] = [
        {
            background: sliderImage1,
            bannerText: "Welcome to HoneyRock",
            bannerTextDescription: "At HoneyRock School we foster growth, creativity and love for learning in every child"
        },
        {
            background: sliderImage2,
            bannerText: "An adventure awaits you in each class",
            bannerTextDescription: 'At HoneyRock School we foster growth, creativity and love for learning in every child'
        },
        {
            background: sliderImage3,
            bannerText: "Inspiring confidence and self expression",
            bannerTextDescription: 'At HoneyRock School we foster growth, creativity and love for learning in every child'
        },
    ];

    let [index, setIndex] = useState(0);
    let delay = 10000;

    useEffect(() => {
        const intervalId = setInterval(
            () =>
                setIndex((prevIndex) =>
                    prevIndex === slideShowItems.length - 1 ? 0 : prevIndex + 1
                ),
            delay
        );

        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, [index]);

    return (
        <div className="slider-page-width">
               <div className="slideshow ">
            <div
                className="slideshowSlider"
                style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
            >
                {slideShowItems.map((slide, index) => {
                    return (
                        <div className="slide" key={index}>
                            <img className="slide-image" src={slide.background} alt="HoneyRock School pupils" />
                           
                            <div className="slide-overlay">
                                <div className="slide-banner">
                                    <div className="slide-text">{slide.bannerText}</div>
                                    <p className="slide-text-description">{slide.bannerTextDescription}</p>
                                    <Button />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
        </div>
    );
};

export default Slider;
